export default "/images/bg.svg?dda898af4b8e5ab35ea2127df3c6d67f";